<script setup lang="ts">
import { GROUPING_SAVE_KEY } from "@/shared/list-filter/composables/grouping-settings";
import { useGroupingToggleDisabled } from "@/shared/list-filter/composables/grouping-toggle-disabled";
import { useGrouping } from "@/shared/grouping/composable/grouping.ts";

const props = defineProps<{
    groupingSaveKey: GROUPING_SAVE_KEY;
}>();

const { isGrouped } = useGrouping(props.groupingSaveKey);
const isDisabled = useGroupingToggleDisabled();
</script>

<template>
    <div>
        <q-toggle
            v-model="isGrouped"
            data-qs="grouping-toggle"
            class="text-no-wrap"
            :label="$t('shared.Grouped Display')"
            :disable="isDisabled"
        />
    </div>
</template>
